import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import PageTitle from 'components/atoms/PageTitle'
import PartnerInventoryTable from 'components/organisms/PartnerInventoryTable'

import { ROLE_READ_ONLY, ROLE_PARTNER_READ_ONLY, useAuth } from '../../auth'

export default function PartnerInventory() {
  const { t } = useTranslation()
  const { hasOneOfRoles } = useAuth()
  const userRoleHasReadOnly = useMemo(
    () => hasOneOfRoles([ROLE_READ_ONLY, ROLE_PARTNER_READ_ONLY]),
    [hasOneOfRoles]
  )

  return (
    <div className="content-container wide">
      <PageTitle label={t('partnerInventory.title')} />
      <PartnerInventoryTable contentIsReadOnly={userRoleHasReadOnly} />
    </div>
  )
}
